/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import React, { useMemo } from "react";
import Helper from "../functions/Helper.js";
import Grid from "../components/Grid.js";
import NCAACourt from "./NCAACourt.js";
import NCAAFullCourt from "./NCAAFullCourt.js";
import NBAFullCourt from "./NBAFullCourt.js";
import NBACourt from "./NBACourt.js";
import HighSchoolCourt from "./HighSchoolCourt.js";
import HighSchoolFullCourt from "./HighSchoolFullCourt.js";
import FIBACourt from "./FIBACourt.js";
import FIBAFullCourt from "./FIBAFullCourt.js";
import Background from "../components/Background.js";

const getCourt = (court, lineColor) => {
  let { type, full } = court;
  switch (type) {
    case "NCAA":
      return full ? (
        <NCAAFullCourt lineColor={lineColor} {...court} />
      ) : (
        <NCAACourt lineColor={lineColor} {...court} />
      );
    case "NBA":
      return full ? (
        <NBAFullCourt lineColor={lineColor} {...court} />
      ) : (
        <NBACourt lineColor={lineColor} {...court} />
      );
    case "FIBA":
      return full ? (
        <FIBAFullCourt lineColor={lineColor} {...court} />
      ) : (
        <FIBACourt lineColor={lineColor} {...court} />
      );
    case "HighSchool":
      return full ? (
        <HighSchoolFullCourt lineColor={lineColor} {...court} />
      ) : (
        <HighSchoolCourt lineColor={lineColor} {...court} />
      );
    default:
      return full ? (
        <NCAAFullCourt lineColor={lineColor} {...court} />
      ) : (
        <NCAACourt lineColor={lineColor} {...court} />
      );
  }
};

export default function Court(props) {
  const SVGCourt = useMemo(() => {
    return getCourt(props.court, props.courtColor.lineColor);
  }, [props.court, props.courtColor]);

  let {
    minX: viewBoxX,
    minY: viewBoxY,
    viewBoxWidth,
    viewBoxHeight,
  } = Helper.getMaxCoordinates(props.court);

  let { mirror = false } = props;

  let mirrorSring = props.court.full ? "scale(1, -1)" : "scale(-1, 1)";
  return (
    <svg
      css={{
        ...(mirror
          ? {
              transform: mirrorSring,
              "& text": { transform: mirrorSring },
              "& foreignObject div": { transform: mirrorSring },
            }
          : {}),
      }}
      className={props.editable ? "draggable" : ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={
        viewBoxX + " " + viewBoxY + " " + viewBoxWidth + " " + viewBoxHeight
      }
      id={props.uId + "_court"}
      fontFamily="Roboto"
      style={{
        ...props.style,
      }}
    >
      <Background courtColor={props.courtColor} court={props.court} />
      {props.editable && props.court.showGridLines && (
        <Grid
          spacing={props.court.gridSpacing}
          court={props.court}
          pixelPerFoot={props.pixelPerFoot}
          courtColor={props.courtColor}
        />
      )}

      {SVGCourt}
      {props.children}
    </svg>
  );
}
